// DYNICTY design tokens + brand asset paths
// Central place. Swap logo file here if it changes.
export const BRAND = {
  name: "Dynicty",
  tagline: "BUILD • GROW • EMPOWER",
  domain: "dynicty.com",
  logo: {
    // Official logo (horizontal, transparent PNG). DO NOT redraw or modify.
    horizontal: "/brand/dynicty-logo.png",
    // Square app icon (favicon source).
    appIcon: "/brand/dynicty-app-icon.png",
  },
};

export const COLORS = {
  bg0: "hsl(234 50% 4%)",   // #05060F
  bg1: "hsl(236 49% 8%)",   // #0B0D24
  bg2: "hsl(234 54% 13%)",  // #12163B
  text: "#F5F7FF",
  blue: "#3B82F6",
  mid: "#6D5EF7",
  purple: "#8B5CF6",
};
